// categoryGraph — turn the taxonomy tree + decks into vis-network nodes/edges.
// Reuses buildPickerModel (lib/categoryTree.js) for the slotting, then flattens
// the resulting tree into a graph: one node per category, one per deck, edges
// parent→child and category→deck. Pure + framework-free for unit testing; the
// QuizzesMap view feeds the result to vis-network.
import { buildPickerModel } from "./categoryTree.js";

const FALLBACK = "#64748b";

export function buildGraph(categories, decks) {
  const { roots } = buildPickerModel(categories, decks);
  const nodes = [];
  const edges = [];

  const walk = (node, parentId) => {
    const id = "c:" + (node.id || node.slug);
    nodes.push({
      id,
      label: node.name,
      kind: "category",
      level: node.level,
      color: node.color || FALLBACK,
      deckCount: node.deckCount
    });
    if (parentId) edges.push({ from: parentId, to: id });
    for (const child of node.children) walk(child, id);
    for (const deck of node.decks) {
      const deckId = "d:" + deck.slug;
      nodes.push({
        id: deckId,
        label: deck.topic,
        kind: "deck",
        slug: deck.slug,
        source: deck.source,
        color: node.color || "#2563eb"
      });
      edges.push({ from: id, to: deckId });
    }
  };

  for (const root of roots) walk(root, null);
  return { nodes, edges };
}
